module.exports = __webpack_public_path__ + "img/ic_bouns.512c3b7b.png";